import { SearchPage } from '@/networks/api'
import types from './types'
import { isErrorStatus } from '@/util/isErrorStatus.js'

export default {
  state() {
    return {
      searchSift: null,
      chooseSift: null,
      siftName: null,
      nameSort: null,
      courseSort: null,
      courseList: [],
      hitTeacher: null,
      noCourserecWord: null,
      noCourserecCourse: null,
      pageCount: 0,
      courseCount: 0,
      dataExpTag: null
    }
  },
  mutations: {
    [types.SET_SEARCH_SIFT](state, payload) {
      state.searchSift = payload
    },
    [types.SET_SEARCH_CHOOSE_SIFT](state, payload) {
      state.chooseSift = payload
    },
    [types.SET_SEARCH_NAME](state, payload) {
      state.siftName = payload
    },
    [types.SET_SEARCH_NAME_SORT](state, payload) {
      state.nameSort = payload
    },
    [types.SET_SEARCH_COURSE_SORT](state, payload) {
      state.courseSort = payload
    },
    [types.SET_SEARCH_COURSE_LIST](state, payload) {
      state.courseList = payload
    },
    [types.SET_HIT_TEACHER](state, payload) {
      state.hitTeacher = payload
    },
    [types.SET_NOCOURSEREC_WORD](state, payload) {
      state.noCourserecWord = payload
    },
    [types.SET_NOCOURSEREC_COURSE](state, payload) {
      state.noCourserecCourse = payload
    },
    [types.SET_PAGENATION_COUNT](state, payload) {
      state.pageCount = payload
    },
    [types.ADD_SEARCH_COURSE_LIST](state, payload) {
      state.courseList = state.courseList.concat(payload)
    },
    [types.SET_COURSE_COUNT](state, payload) {
      state.courseCount = payload
    },
    [types.UPDATA_COURSE_LIST](state, payload) {
      for (let key in payload) {
        const index = state.courseList.findIndex(item => Number(item.id) === Number(key))
        if (index !== -1) {
          if ('resale' in payload[key]) {
            state.courseList[index].price.resale = payload[key].resale
          }
          if ('classLimitNum' in payload[key]) {
            state.courseList[index].class.leftNum = payload[key].classLimitNum
          }
        }
      }
    },
    [types.SET_DATA_EXP_TAG](state, payload) {
      state.dataExpTag = payload
    }
  },
  actions: {
    async [types.GET_SEARCH_SIFT]({ commit, rootState }, { route }) {
      try {
        const { query } = route

        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        const currentGrade = rootState.cookies.currentGrade
        const page_grade = Number(currentGrade) ?  Number(currentGrade) : Number(userGrade)

        const { data, headers } = await SearchPage.getSearchFilter({
          rootState,
          params: {
            keyword: '直播课',
            flag: 1,
            ...query,
            xesid: rootState.cookies.xesId,
            devid: 1,
            page_grade: page_grade
          }
        })
        // console.log('===GET_SEARCH_SIFT====', headers)
        // 筛选项
        commit(types.SET_SEARCH_SIFT, data.sift)
        // 已选中的筛选条件
        commit(types.SET_SEARCH_CHOOSE_SIFT, data.chooseSift)
        // 筛选项名称
        commit(types.SET_SEARCH_NAME, data.name)
        // 筛选项名称排序
        commit(types.SET_SEARCH_NAME_SORT, data.namesort)
        // 课程排序
        commit(types.SET_SEARCH_COURSE_SORT, data.sort)
        // 实验标签
        commit(types.SET_DATA_EXP_TAG, headers['x-data-exp-tag'])
      } catch (e) {
        // 筛选项
        commit(types.SET_SEARCH_SIFT, null)
        // 已选中的筛选条件
        commit(types.SET_SEARCH_CHOOSE_SIFT, null)
        // 筛选项名称
        commit(types.SET_SEARCH_NAME, null)
        // 筛选项名称排序
        commit(types.SET_SEARCH_NAME_SORT, null)
        // 课程排序
        commit(types.SET_SEARCH_COURSE_SORT, null)
        commit(types.SET_DATA_EXP_TAG, null)
      }
    },
    async [types.GET_SEARCH_COURSE_LIST](
      { dispatch, commit, state, rootState },
      { sort, page, route }
    ) {
      try {
        const { query } = route

        const userGrade = rootState.cookies.userGrade ? rootState.cookies.userGrade : 4
        const currentGrade = rootState.cookies.currentGrade
        const page_grade = Number(currentGrade) ?  Number(currentGrade) : Number(userGrade)

        const { data, headers } = await SearchPage.getSearchCourseList({
          rootState,
          params: {
            keyword: '直播课',
            ...query,
            sort: sort || 1,
            curpage: page || 1,
            xesid: rootState.cookies.xesId,
            devid: 1,
            page_grade: page_grade
          }
        })
        if (isErrorStatus(data)) {
          commit(types.SET_SEARCH_COURSE_LIST, null)
          commit(types.SET_NOCOURSEREC_COURSE, null)
          commit(types.SET_HIT_TEACHER, null)
          commit(types.SET_NOCOURSEREC_WORD, null)
          return
        }
        // console.log('==GET_SEARCH_COURSE_LIST===', data.list.length)
        if (page > 1) {
          commit(types.ADD_SEARCH_COURSE_LIST, data.list)
        } else {
          commit(types.SET_SEARCH_COURSE_LIST, data.list)
        }
        commit(types.SET_PAGENATION_COUNT, Number(headers['x-pagenation-count'])) // 页数
        commit(types.SET_COURSE_COUNT, headers['x-course-count'])
        // 搜索到的课程列表
        // 老师卡片
        commit(types.SET_HIT_TEACHER, data.hitTeacher)
        commit(types.SET_NOCOURSEREC_WORD, data.noResultRec.word)
        commit(types.SET_NOCOURSEREC_COURSE, data.noResultRec.course)
        // commit(types.SET_PAGENATIONCOUNT, Number(headers['x-pagenation-count'])) // 页数
      } catch (e) {
        console.log(e)
        commit(types.SET_SEARCH_COURSE_LIST, null)
        commit(types.SET_NOCOURSEREC_COURSE, null)
        commit(types.SET_HIT_TEACHER, null)
        commit(types.SET_NOCOURSEREC_WORD, null)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/SearchPage/store/index.js